import { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logo from '../assets/logo.png';

export default function Footer() {

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-custom-dark text-custom-light pt-4 pb-2 mt-auto">
      <Container>
        <Row className="text-center text-md-start">
          <Col md={4} className="mb-3">
            <img src={logo} alt="Sanjay Enterprises Logo" style={{ maxWidth: '150px' }} className="mb-2" />
            <h5>Sanjay Enterprises</h5>
            <p>Where Ideas meet Reality</p>
            <p>Quality and precision for all your manufacturing needs.</p>
          </Col>
          <Col md={4} className="mb-3">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-white text-decoration-none">Home</a></li>
              <li><a href="/about" className="text-white text-decoration-none">About</a></li>
              <li><a href="/products" className="text-white text-decoration-none">Products</a></li>
              <li><a href="/services" className="text-white text-decoration-none">Services</a></li>
              <li><a href="/contact" className="text-white text-decoration-none">Contact</a></li>
            </ul>
          </Col>
          <Col md={4} className="mb-3">
            <h5>Contact Us</h5>
            <p><a className="footer-contact" href="mailto:sales@sanjayenterprises.co.in"><i className="bi bi-envelope me-2"></i>sales@sanjayenterprises.co.in</a></p>
            <p><a className="footer-contact" href="tel:+919607009796"><i className="bi bi-telephone me-2"></i>+91 96070 09796</a></p>
            <p><a className="footer-contact" href="tel:+917888159898"><i className="bi bi-telephone me-2"></i>+91 78881 59898</a></p>
            <div>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="https://www.linkedin.com/company/107351648/admin/dashboard/" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white">
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </Col>
        </Row>
        <hr className="border-secondary" />
        <p className="text-center mb-0">&copy; 2025 Sanjay Enterprises - All rights reserved.</p>
        {showButton && (
          <button
            onClick={scrollToTop}
            className="btn scroll-to-top-btn position-fixed end-0 bottom-0 m-4"
            style={{ borderRadius: '20%', width: '50px', height: '50px', zIndex: 1000 }}
            aria-label="Scroll to top"
          >
            <i className="bi bi-arrow-up-short fs-4"></i>
          </button>
        )}

      </Container>
    </footer>
  );
}
